import axios from "axios";
import React, { Component, useEffect, createRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import qs from "query-string";
import { Chart } from "react-google-charts";
import $ from "jquery";
import dt from "datatables.net";
import "css/reportes/scrollbar.css";
import typeahead from "corejs-typeahead";
import { Helpers, Redux, Templates } from "@ora/recursos";
const { PageLength } = Helpers.DataTables;
const { set_datapage, getMapStateDefault } = Redux.Actions.DataPageAction;
const {
  checkDataDirectorio,
  // seDataDirectorio,
  seDatatDocumentos,
} = Redux.Actions.DirectoriosActions;
const { baseUrl, localUrl } = Helpers.Url;
$.DataTable = dt;
$.typeahead = typeahead;

class PermisoCites extends Component {
  filter = {
    buscar: "",
  };

  datatable = null;

  constructor(props) {
    super(props);
    // this.props.set_datapage({ titulo: 'Permiso CITES',
    //                         isbackend:false,
    //                         be_itemselect:"permiso_cites",//clave de item del menu backend que se debe activar
    //                         breadcrumb:[
    //                             {name:"Inicio",url:localUrl("/")},
    //                             {name:"Reportes",url:"#"},
    //                             {name:"Permiso CITES",url:"#",active:true},
    //                         ]});
    this.spinnerLoad = createRef();
    this.Buscarsp = createRef();

    this.state = {
      lista: false,
      cites: false,
      iucn: false,
      paisesData: [],
      especieChart: [],
      paises: false,
      recursos: false,
      tiporecurso: false,
      typeChart: 'default',
      charts: {
        A: null,
        B: null,
      },
      search: {
        txt_ncc: "",
        sel_year: "",
        sel_iucn: "",
        sel_recurso: "",
        sel_tiporecurso: "",
        sel_pais: "",
      },
      regpag: process.env.REG_PAG,
      dataLoadingStatus: "loading",
      chartData: [],
      total: 0,
      datosCargados: false,
    };
  }

  setDataPage = () => {
    this.props.set_datapage({
      titulo: this.props.language("reporte_titulo_permisos", "Permisos CITES"),
      isbackend: false,
      hasHeroBar: true,
      hasBreadcrumb: false,
      be_itemselect: "permiso_cites", //clave de item del menu backend que se debe activar
      breadcrumb: [
        { name: "Inicio", url: localUrl("/") },
        { name: "Reportes", url: "#" },
        { name: "Permiso CITES", url: "#", active: true },
      ],
    });
  };
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (100 === +this.props.countDataPage) {
      console.log("pipipipipipipipipipi countDataPage");

      this.setDataPage();
    }
  }
  componentWillUnmount() {
    // if (this.requestInit) this.requestInit.cancel();
    // if (this.requestDatatable) this.requestDatatable.abort();
    $("#txt_ncc")
      .typeahead('destroy')
  }
  initTypeahead = () => {
    // $('#txt_ncc').typeahead({
    // hint: true,
    // highlight: true,
    // minLength: 1
    // },
    // {
    // name: 'states',
    // source: substringMatcher(states)
    // });
    // var _this = this

    const fnTargetText = (e, data) => {
      this.setState({
        search: {
          ...this.state.search,
          txt_ncc: data.text,
        },
      });
    };
    $("#txt_ncc")
      .typeahead(
        {
          highlight: true,
          hint: false,
          minLength: 1,
        },
        {
          async: true,
          name: "search-permisos",
          display: function display(d) {
            return d.text;
          },
          templates: {
            suggestion: (h) => {
              if (h.asPlaceholder !== undefined) {
                return `<div>Buscar<b>"${h.text}"</b></div>`;
              } else return `<div>${h.text}</div>`;
            },
          },
          source: function source(q, cb, asy) {
            // let result = []
            if (q.trim() != "") {
              // var no_buscar = _this.cilindros.map(function (v) {
              //     return v.id;
              // });
              // console.log(no_buscar);
              // axios.get(BASE_URL + '/api/cilindro?m=all&q=' + q, {params: {cilindros: no_buscar}}).then(res => {
              cb([{ count: 0, asPlaceholder: true, text: q.trim() }]);
              axios
                .get(baseUrl("cites/permisos/typeahead"), {
                  params: { q: q.trim() },
                })
                .then(function (res) {
                  // console.log(res.data)
                  // return res.data
                  // res.data.unshift({count: 0, text: `Solo buscar "${q.trim()}"` })
                  asy(res.data);
                  // return res.data
                });

              // let regex = new RegExp(q, 'i');
              // cb(_this.listaBancos.filter(v => {
              //   return regex.test(v.banco_name)
              // }))
            }
          },
        }
      )
      .bind("typeahead:select", fnTargetText)
      .bind("typeahead:autocomplete", fnTargetText);
  };

  componentDidMount() {
    var params = qs.parse(this.props.location.search);
    var url = baseUrl(`cites/reportes/initpermiso?l=25&o=0`);

    var search = this.state.search;
    if (params["q1"]) {
      search["txt_ncc"] = params["q1"];
      url += "&q1=" + params["q1"];
    }
    if (params["q2"]) {
      search["sel_year"] = params["q2"];
      url += "&q2 n=" + params["q2"];
    }
    if (params["q3"]) {
      search["sel_iucn"] = params["q3"];
      url += "&q3=" + params["q3"];
    }
    if (params["q4"]) {
      search["sel_tiporecurso"] = params["q4"];
      url += "&q4=" + params["q4"];
    }
    console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbbbbb', search)
    this.setState({
      search: search,
    });
    axios.get(url).then((res) => {
      this.initpage(res.data);
      this.setDataPage();
    });
  }
  cargarchartbarrasmultiples(
    datos,
    data_x_column,
    axis_y_column,
    x,
    name_x,
    y,
    y_first_name,
    name_y,
    charName,
    confObjChar
  ) {
    // let year = [
    //     ['Años', 'Cantidad']
    // ]

    if (datos === undefined) return false;
    let DataChart = [];
    let filaDatachart = [];
    let row;
    let isFirstRow = true;
    let total_data = 0;

    let arrayData = Object.entries(datos);

    console.log(arrayData);

    console.log(x);
    console.log(y);

    y.map((y_el) => {
      //CABECERA
      if (isFirstRow) {
        filaDatachart.push(y_first_name);
        x.map((x_el) => {
          filaDatachart.push(x_el[name_x]);
        });
        DataChart.push(filaDatachart);
        filaDatachart = [];
      }

      //CONTENIDO
      filaDatachart.push(y_el[name_y]); //PRIMER ELEMENTO DEL ROW
      //console.log(data[1].pais)
      x.map((x_el) => {
        let i = x_el[name_x];
        let j = y_el[name_y];

        //console.log(j)
        //console.log(i)

        row = arrayData.find(
          (data) => data[1][data_x_column] == i && data[1][axis_y_column] == j
        ); //CONDICION

        if (row) {
          //SI EXISTE EL ELEMENTO CON ESA CONDICION´
          total_data = total_data + 1;
          filaDatachart.push(parseInt(row[1].cantidad)); //AGREGA EL ATRIBUTO SOLICITADO
        } else filaDatachart.push(0);
      });

      DataChart.push(filaDatachart);
      filaDatachart = [];
      isFirstRow = false;
      return y_el;
    });

    this.setState({
      [charName]: this.renderChart(DataChart, total_data, confObjChar),
      dataLoadingStatus: "ready",
    });
  }
  renderChart(data, total_data, objConf) {
    if (total_data > 0) {
      let CharTitle = objConf.CharTitle;
      let hAxisTitle = objConf.hAxisTitle;
      let vAxisTitle = objConf.vAxisTitle;
      let id = objConf.id;

      return (
        <Chart
          width={"100%"}
          height={"400px"}
          chartType="BarChart"
          loader={<div>Loading Chart</div>}
          data={data}
          options={{
            legend: {
              position: "bottom",
              textStyle: { fontSize: 11 },
              maxLines: 3,
            },
            title: CharTitle,
            chartArea: { width: "65%" },
            isStacked: true,
            hAxis: {
              title: hAxisTitle,
              minValue: 0,
            },
            vAxis: {
              title: vAxisTitle,
            },
          }}
          // For tests
          rootProps={{ "data-testid": id }}
        />
      );
    } else {
      return (
        <div className="is-3">
          {" "}
          <b> No se encontraron decomisos para este gráfico</b>
        </div>
      );
    }
  }
  initpage(result) {
    var resultados = result;
    console.info("%c--- get reporte ", "color:yellow;background:green");
    var search = this.state.search;
    const itemYear = resultados.year.map((item, index) => {
      var selected = false;

      if (this.state.search["sel_year"] == item.per_int_year) {
        search["sel_year"] = item.per_int_year;
        selected = true;
      }
      return (
        <option
          key={item.per_int_year + "-" + index}
          value={item.per_int_year}
          selected={selected}
        >
          {item.per_int_year}
        </option>
      );
    });
    const itemPaises = resultados.paises.map((item, index) => {
      var selected = false;
      if (this.state.search["sel_iucn"] == item.name) {
        search["sel_iucn"] = item.name;
        selected = true;
      }
      return (
        <option
          key={item.code + "-" + index}
          value={item.code}
          selected={selected}
        >
          {item.name}
        </option>
      );
    });
    
    this.setState({
      year: itemYear,
      paises: itemPaises,
      paisesData: resultados.paises,
      search: search,
      dataLoadingStatus: 'ready'
    }, () => {
        this.initTypeahead();
        this.initDatatable();
        this.getSearch();
    });
  }

  initDatatable = () => {
    const OnClick_acciones = (evt) => {
      let { accion, id } = evt.currentTarget.dataset;
      switch (accion) {
        case "ver":
          this.props.history.push(localUrl("/reportes/permisos/" + id));
          break;
      }
    };
    this.configDT = {
      data: [],
      dom: "<'columns'<'column is-full'<'table-container't>>><'columns p-4'<'column'l><'column'p>>",
      processing: true,
      pageLength: PageLength(),
      ajax: {
        url: baseUrl("cites/reportes/permiso_datatable?l=25&o=0&tq=1"),
        data: (d) => {
          d.filter = {
            q1: this.state.search["txt_ncc"],
            q2: this.state.search["sel_year"],
            q3: this.state.search["sel_iucn"],
            q4: this.state.search["sel_tiporecurso"],
          };
          return d;
        },
      },
      serverSide: true,
      order: [[0, "asc"]],
      createdRow: (r, d, i) => {},
      columns: [
        { data: "index" },
        { data: "per_int_year" },
        { data: "per_text_taxon" },
        { data: "per_int_quantity" },
        { data: "per_text_unit" },
        { data: "pais_exporter" },
        { data: "pais_importer" },
        { data: "per_text_date" },
        {
          data: "per_int_id",
          render: (d, t, r) => {
            return `
                  <div class="buttons is-centered">
                  <button data-id="${d}" data-accion="ver" class="button is-small is-primary btn-acciones buttonb" title="Ver">
                      <span class="icon is-small"><i class="fas fa-eye"></i></span>
                  </button>
              </div>
                    `;
          },
        },
      ],
      drawCallback: () => {
        $("#tblPermiso_paginate a.previous").addClass(
          "pagination-link pagination-previous"
        );
        $("#tblPermiso_paginate a.next").addClass(
          "pagination-link pagination-next"
        );
        $("#tblPermiso_paginate a.next").addClass(
          "pagination-link pagination-next"
        );
        $("#tblPermiso_paginate span a.paginate_button.current").addClass(
          "pagination-link is-current"
        );
        $("#tblPermiso_paginate span a.paginate_button").addClass(
          "pagination-link"
        );
      },
    };
    this.table = $("#tblPermiso");

    // setTimeout(() => {

    this.datatable = this.table
      .DataTable(this.configDT)
      .on("click", ".btn-acciones", OnClick_acciones)
      .on("xhr.dt", (e, setting, json, xhr) => {
        this.setState({
          total: json.recordsFiltered
        })
      })

    // }, 20000)
  };

  cargarregistros(datos) {
    const listaItems = datos.registros.map((item, index) => {
      return (
        <tr key={"registro_" + item.per_int_id}>
          <td className="is-checkbox-cell">{index + 1}</td>
          <td>{item.per_int_year}</td>
          <td>{item.per_text_taxon}</td>
          <td>{item.per_int_quantity}</td>
          <td>{item.per_text_unit}</td>
          <td>{item.pais_exporter}</td>
          <td>{item.pais_importer}</td>
          <td>{item.per_text_date}</td>
          <td className="is-actions-cell">
            <div className="buttons is-right">
              <Link
                className="button is-small is-primary"
                to={localUrl("/reportes/permisos/" + item.per_int_id)}
              >
                <span className="icon">
                  <i className="mdi mdi-eye"></i>
                </span>
              </Link>
            </div>
          </td>
        </tr>
      );
    });
    this.setState({
      lista: listaItems,
      total: datos.total,
    });
  }
  cargarchartyear(datos) {
    let year = [["Años", "Cantidad"]];

    datos.yearchart.map((item, index) => {
      //console.log(datos.yearchart)
      year.push([item.per_int_year, parseInt(item.cantidad)]);
    });
    console.log("bbbbbbbbbbbbbbb year", year);
    this.setState({
      yearChart: year,
      dataLoadingStatus: "ready",
    });
    
  }

  cargarchartimporter(datos) {
    let importador = [["Task", "Hours per Day"]];
    datos.importerchart.map((item, index) => {
      //console.log(datos.yearchart)
      importador.push([item.pais_importer, parseInt(item.cantidad)]);
    });
    this.setState({
      importadorChart: importador,
    });
  }
  onClick_descargar = (e) => {
    e.preventDefault()
    let tokenDownload = Helpers.ValidationAuth.getPublicAuthorization().replace('Basic', '').replace(' ', '').trim()
    let params = this.datatable.ajax.params()
    window.open(baseUrl("cites/reportes/permiso_datatable?l=25&o=0&tq=1") + '&' + $.param(params) + '&format=download' + (tokenDownload ? `&token=${tokenDownload}` : ''), '_blank').focus();
  }
  cargarchartespecie(datos) {
    let especie = [["Especie", "Cantidad"]];
    datos.especiechart.map((item, index) => {
      //console.log(datos.yearchart)
      especie.push([item.per_text_taxon, parseInt(item.cantidad)]);
    });
    console.log('nnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn', especie)
    this.setState({
      especieChart: especie,
    });
  }

  buscar_simple = () => {
    this.datatable.destroy();
    this.getSearch();
    //alert(window.$('#spinnerCargando'))
    var url = this.getParamsUrl("/reportes/permiso?");
    this.props.history.push(localUrl(url));
    //this.Buscarsp.current.classList.remove('is-hidden')
    //this.Buscarsp.current.classList.add('is-hidden')
    $("#btnBuscar").addClass("is-loading");
  };
  getSearch() {
    console.log("bbbbbbbbbbbbbbbbbbbbbb search");
    var url = this.getParamsUrl("cites/reportes/permiso?l=25&o=0&tq=1");
    url = baseUrl(url);

    axios.get(url).then((res) => {
    $("#btnBuscar").removeClass("is-loading");
    this.setState({ 
        datosCargados: true ,
        dataLoadingStatus: 'ready',
        typeChart: res.data.function
    });
    if (res.data.function === 'default') {
        // alert('asd')
        this.cargarregistros(res.data.datos);
        this.cargarchartyear(res.data.datos);
        // this.cargarchartappendice(res.data.datos);
        // this.cargarchartexporter(res.data.datos);
        // this.cargarchartimporter(res.data.datos);
        this.cargarchartespecie(res.data.datos);
    } else {

        this[res.data.function](res.data.datos)
    }

    
    });
  }

  func_q1 = (baseData) => {
    console.log('vvvvvvvv', baseData)
    let data = baseData.A
    let dataB = baseData.B
    
    let paises = []
    let lastFindPais = ''
    data.forEach(pais => {
        if (lastFindPais !== pais.cod) {
            let find = paises.find(p => p.cod === pais.cod)
            if (find === undefined) {
                lastFindPais = pais.cod
                paises.push({
                    cod: pais.cod,
                    pais: pais.pais
                })
            }
        }
        
    })
    let body = []
    let lastIndexP = -1
    lastFindPais = ''
    data.forEach(item => {
        if (+item.per_int_year <= 0) return false;
        if (lastFindPais !== item.cod) {
            lastIndexP = paises.findIndex(p => p.cod === item.cod)
        }
        let find =  body.find(b => b[0] === item.per_int_year)
        if (find === undefined) {
            let _body = new Array(paises.length)
            _body.fill(0)
            _body[lastIndexP] = +item.cantidad
            find = [item.per_int_year, ..._body]
            body.push(find)
        } else {
            find[lastIndexP + 1] = +item.cantidad
        }
        
        



    })
    let bFinal = [['Pais', ...paises.map(item => item.pais)]].concat(body)

    //CUADRO B

    let header = []
    let lastFindHeader = ''
    dataB.forEach(pais => {
        if (pais.per_text_product === null ) return;
        if (lastFindHeader !== pais.per_text_product) {
            let find = header.find(p => p.cod === pais.per_text_product)
            if (find === undefined) {
                lastFindHeader = pais.per_text_product
                header.push({
                    cod: pais.per_text_product,
                })
            }
        }
        
    })
    console.log('bbbbbbbbbbbb', header)
    let bodyB = []
    let lastIndexPB = -1
    lastFindHeader = ''
    dataB.forEach(item => {
        if (+item.per_int_year <= 0 || item.per_text_product === null) {
            return;
        }
        
        if (lastFindHeader !== item.per_text_product) {
            lastIndexPB = header.findIndex(p => p.cod === item.per_text_product)
            lastFindHeader = item.per_text_product
        }
        let find =  bodyB.find(b => b[0] === item.per_int_year)
        if (find === undefined) {
            let _body = new Array(header.length)
            _body.fill(0)
            _body[lastIndexPB] = +item.cantidad
            find = [item.per_int_year, ..._body]
            bodyB.push(find)
        } else {
            find[lastIndexPB + 1] = +item.cantidad
        }
        
        



    })
    let bFinalB = [['Presentaciones', ...header.map(item => item.cod)]].concat(bodyB)



    // console.log(paises)
    // console.log(body)
    console.log(bFinalB)
    this.setState({
        charts: {
            A: this.renderChart(bFinal, 1, {
                CharTitle : this.props.language('rep_perm_graficoq1A', 'Cantidad de Permisos CITES por año desde los Países Miembros de la OTCA en los 10 últimos años de la especie: ') + this.state.search.txt_ncc,
                hAxisTitle: 'Pais',
                vAxisTitle: 'Año',
                id: '1'
            }),
            B: this.renderChart(bFinalB, 1, {
                CharTitle : this.props.language('rep_perm_graficoq1B', 'Cantidad de Permisos CITES de Presentaciones por año desde los países Miembros en los 10 últimos años de la especie: ') + this.state.search.txt_ncc,
                hAxisTitle: 'Presentación',
                vAxisTitle: 'Año',
                id: '1'
            })
        }
    })
    

  }
  generateMultiple = (data, column) => {
    let header = []
    let lastFindHeader = ''
    data.forEach(value => {
        if (value[column] === null ) return;
        if (lastFindHeader !== value[column]) {
            let find = header.find(p => p.cod === value[column])
            if (find === undefined) {
                lastFindHeader = value[column]
                header.push({
                    cod: value[column],
                })
            }
        }
        
    })
    console.log('bbbbbbbbbbbb', header)
  }
  simple_q2 = (data, name = 'name') => {
    let header = []
    let lastFindHeader = ''
    data.forEach(value => {
        value.coda = JSON.parse(value.coda)
        value.coda.forEach(coda => {
            let find = header.find(head => head === coda[1])
            if (find === undefined) {
                header.push(coda[1])
            }
        })
        
    })
    console.log('bbbbbbbbbbbb', header)
    let bodyB = []
    bodyB = data.map(item => {
        console.log('bbbbbbbbbbbbxxxxxxx', item);
        
        let _body = new Array(header.length)
        _body.fill(0)
        item.coda.forEach(coda => {
            let find = header.findIndex(head => head === coda[1])
            if (find >= 0) {
                _body[find] = +coda[2]
            }
        })
        return [item.target, ..._body]
    })
    return [[name, ...header]].concat(bodyB)
  }
  simple_q3 = (data, name = 'name') => {
    let header = []
    let lastFindHeader = ''
    data.forEach(value => {
        value.coda = JSON.parse(value.coda)
        value.coda.forEach(coda => {
            let find = header.find(head => head === coda[0])
            if (find === undefined) {
                header.push(coda[0])
            }
        })
        
    })
    header = header.sort((a, b) => a - b)
    console.log('bbbbbbbbbbbb', header)
    let bodyB = []
    bodyB = data.map(item => {
        console.log('bbbbbbbbbbbbxxxxxxx', item);
        
        let _body = new Array(header.length)
        _body.fill(0)
        item.coda.forEach(coda => {
            let find = header.findIndex(head => head === coda[0])
            if (find >= 0) {
                _body[find] = +coda[1]
            }
        })
        return [item.target, ..._body]
    })
    return [[name, ...header]].concat(bodyB)
  }
  func_q2 = (baseData) => {
    console.log('vvvvvvvv', baseData)
    let data = baseData.A
    let dataB = baseData.B
    
  

    //CUADRO A

    let header = []
    let lastFindHeader = ''
    data.forEach(value => {
        value.coda = JSON.parse(value.coda)
        value.coda.forEach(coda => {
            let find = header.find(head => head === coda[1])
            if (find === undefined) {
                header.push(coda[1])
            }
        })
        
    })
    console.log('bbbbbbbbbbbb', header)
    let bodyB = []
    let lastIndexPB = -1
    lastFindHeader = ''
    bodyB = data.map(item => {
        console.log('bbbbbbbbbbbbxxxxxxx', item);
        
        let _body = new Array(header.length)
        _body.fill(0)
        item.coda.forEach(coda => {
            let find = header.findIndex(head => head === coda[1])
            if (find >= 0) {
                _body[find] = +coda[2]
            }
        })
        return [item.target, ..._body]
    })
    console.log('bbbbbbbbbbbb', bodyB)

  
        



    // })
    let bFinalB = [['Presentaciones', ...header]].concat(bodyB)
    let bFinalBB = this.simple_q2(dataB, 'Presentaciones')


    // console.log(paises)
    // console.log(body)
    console.log('bbbbbbbbbbbb', bFinalB)
    this.setState({
        charts: {
            A: this.renderChart(bFinalB, 1, {
                CharTitle : this.props.language('rep_perm_graficoq2A', 'Lista de 10 especies con mas Permisos CITES desde los Países Miembros de la OTCA en el año: ') + this.state.search.sel_year,
                hAxisTitle: 'País',
                vAxisTitle: 'Especies',
                id: '1'
            }),
            B: this.renderChart(bFinalBB, 1, {
                CharTitle : this.props.language('rep_perm_graficoq2B', 'Lista de las 10 presentaciones con mas Permisos CITES desde los países Miembros de la OTCA en el año: ') + this.state.search.sel_year,
                hAxisTitle: 'País',
                vAxisTitle: 'Presentación',
                id: '1'
            })
        }
    })
  }
  func_q3 = (baseData) => {
    let data = baseData.A
    let dataB = baseData.B
    
    let bFinalA = this.simple_q3(data, 'Presentaciones')

    let bFinalBB = this.simple_q3(dataB, 'Presentaciones')
    let pais = this.state.paisesData.find(item => item.code === this.state.search.sel_iucn)
    console.log('xxxxxx',pais,this.state.paisesData, this.state.search)
    this.setState({
        charts: {
            A: this.renderChart(bFinalA, 1, {
                CharTitle : this.props.language('rep_perm_graficoq3A', 'Lista de 10 especies con mas Permisos CITES de exportación emitidas por: ') + pais.name,
                hAxisTitle: 'País',
                vAxisTitle: 'Especies',
                id: '1'
            }),
            B: this.renderChart(bFinalBB, 1, {
                CharTitle : this.props.language('rep_perm_graficoq3B', 'Lista de las 10 presentaciones con más Permisos CITES de exportación emitidas por: ') + pais.name,
                hAxisTitle: 'País',
                vAxisTitle: 'Presentación',
                id: '1'
            })
        }
    })
  }
  func_q4 = (baseData) => {
    let data = baseData.A
    let dataB = baseData.B
    
    let bFinalA = this.simple_q3(data, 'Presentaciones')

    let bFinalBB = this.simple_q3(dataB, 'Presentaciones')
    let pais = this.state.paisesData.find(item => item.code === this.state.search.sel_tiporecurso)
    console.log('xxxxxx',pais,this.state.paisesData, this.state.search)
    this.setState({
        charts: {
            A: this.renderChart(bFinalA, 1, {
                CharTitle : this.props.language('rep_perm_graficoq4A', 'Lista de 10 especies con mas Permisos CITES de importación emitidas por: ') + pais.name,
                hAxisTitle: 'País',
                vAxisTitle: 'Especies',
                id: '1'
            }),
            B: this.renderChart(bFinalBB, 1, {
                CharTitle : this.props.language('rep_perm_graficoq4B', 'Lista de las 10 presentaciones con más Permisos CITES de importación emitidas por: ') + pais.name,
                hAxisTitle: 'País',
                vAxisTitle: 'Presentación',
                id: '1'
            })
        }
    })
  }
  getParamsUrl(url) {
    if (this.state.search["txt_ncc"] != "") {
      url += "&q1=" + this.state.search["txt_ncc"];
    }
    if (this.state.search["sel_year"] != "") {
      url += "&q2=" + this.state.search["sel_year"];
    }
    if (this.state.search["sel_iucn"] != "") {
      url += "&q3=" + this.state.search["sel_iucn"];
    }
    if (this.state.search["sel_tiporecurso"] != "") {
      url += "&q4=" + this.state.search["sel_tiporecurso"];
    }

    return url;
  }

  ir_detalle = (e) => {
    const { especie } = e.target.dataset;
    var url = "/reportes/fichaespecie/" + especie;
    this.props.history.push(localUrl(url));
  };

  gestionarCambio = (event) => {
    var search = this.state.search;
    if (event.target.type === "radio") {
      search[event.target.name] = event.target.value;
    } else {
      search[event.target.id] = event.target.value;
    }
    this.setState({
      search: search,
    });
  };

  render() {
    return this.state.dataLoadingStatus === "ready" ? (
      <Templates.Default.BasePageRoute2
        localUrl={localUrl}
        dataPage={this.props.DataPage}
      >
        <div>
          <section className="sectiony is-main-section">
            <div className="card">
              <header className="card-header">
                <p className="card-header-title">
                  {this.props.language("filtro", "Filtro")}
                </p>
              </header>
              <div className="card-content">
                <div className="field is-horizontal">
                  <div className="field-body">
                    <div className="field">
                      <label className="label">{this.props.language("rep_perm_nombrecientifo","Nombre Científico")}</label>
                      <div className="control">
                        <input
                          className="input is-expanded"
                          id="txt_ncc"
                          size="50"
                          type="text"
                          autoComplete="off"
                          placeholder="Ingrese nombre cientifico o común"
                          onChange={this.gestionarCambio}
                          value={this.state.search.txt_ncc}
                        ></input>
                      </div>
                    </div>
                    <div className="field">
                      <label className="label">{this.props.language("year","Año")}</label>
                      <div className="control">
                        <div className="select">
                          <select id="sel_year" onChange={this.gestionarCambio}>
                            <option value="">
                              --{" "}{this.props.language("seleccionar","Seleccionar")}{" "} --
                            </option>
                            {this.state.year}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="field ">
                      <label className="label">{this.props.language("rep_perm_paisexport","País exportador")}</label>
                      <div className="control">
                        <div className="select">
                          <select id="sel_iucn" onChange={this.gestionarCambio}>
                            <option value="">
                              --{" "}
                              {this.props.language(
                                "seleccionar",
                                "Seleccionar"
                              )}{" "}
                              --
                            </option>
                            {this.state.paises}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="field ">
                      <label className="label">{this.props.language("rep_perm_paisimport","País importador")}</label>
                      <div className="field is-grouped">
                        <div className="control">
                          <div className="select">
                            <select
                              id="sel_tiporecurso"
                              onChange={this.gestionarCambio}
                            >
                              <option value="">
                                --{" "}
                                {this.props.language(
                                  "seleccionar",
                                  "Seleccionar"
                                )}{" "}
                                --
                              </option>
                              {this.state.paises}
                            </select>
                          </div>
                        </div>
                        <p className="control">
                          <button id="btnBuscar" className="button is-link" onClick={this.buscar_simple}>{this.props.language("buscar","Buscar")}</button>
                        </p>
                        {/*
                                            <div className="pt-2">
                                            <div id="spinnerCargando" className="ld ld-spinner ld-spin is-hidden">
                                            </div>
                                        </div>
                                            */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <header className="card-header">
                <p className="card-header-title">
                  {this.props.language("rep_perm_resumen", "Resumen")}
                </p>
              </header>
              <div className="card-content">
                <div className="columns">
                  <div className="column is-12">
                    { this.state.typeChart !== 'default' ? 
                    this.state.charts.A
                    : null
                    }
                    {this.state.typeChart === 'default' && this.state.yearChart !== undefined &&  this.state.yearChart.length > 1 ? (
                      <Chart
                        width={"100%"}
                        height={"500px"}
                        chartType="BarChart"
                        loader={<div>Loading Chart</div>}
                        data={this.state.yearChart}
                        options={{
                          // Material design options
                          //legend: {position: 'bottom', textStyle: {fontSize: 11},maxLines:3},
                          legend: {
                            position: "bottom",
                            textStyle: { fontSize: 11 },
                            maxLines: 3,
                          },
                          title:
                            this.props.language('rep_perm_grafico1A','Cantidad de permisos por año desde los países miembros de la OTCA en los 10 últimos años'),
                          chart: {
                            title:
                              "Cantidad de exportaciones por año desde los países miembros de la OTCA en los 10 últimos años",
                          },
                          vAxis: {
                            minValue: 0,
                            maxValue: 1000,
                          },
                        }}
                        // For tests
                        rootProps={{ "data-testid": "2" }}
                      />
                    ) : (
                        this.state.typeChart === 'default' ?
                      <b>
                        {this.props.language(
                          "nse_registros",
                          "No se encontraron registros"
                        )}
                      </b> : null
                    )}
                  </div>
                  <div className="field-body"></div>
                </div>
                <div className="columns">
                  <div className="column is-12">
                  { this.state.typeChart !== 'default' ? 
                    this.state.charts.B
                    : null
                    }
                    {this.state.typeChart === 'default' && this.state.especieChart?.length > 1 ? (
                      <Chart
                        width={"100%"}
                        height={"500px"}
                        chartType="BarChart"
                        loader={<div>Loading Chart</div>}
                        data={this.state.especieChart}
                        options={{
                          // Material design options
                          //legend: {position: 'bottom', textStyle: {fontSize: 11},maxLines:3},
                          legend: {
                            position: "bottom",
                            textStyle: { fontSize: 11 },
                            maxLines: 3,
                          },
                          title:
                            this.props.language('rep_perm_grafico1B','Lista de las 10 especies con más permisos desde los países miembros de la OTCA'),
                          chart: {},
                          vAxis: {
                            minValue: 0,
                            maxValue: 1000,
                          },
                        }}
                        // For tests
                        rootProps={{ "data-testid": "2" }}
                      />
                    ) : (
                        this.state.typeChart === 'default'  ?
                      <b>
                        {this.props.language(
                          "nse_registros",
                          "No se encontraron registros"
                        )}
                      </b> : null
                    )}
                  </div>
                  {/* <div className="field-body">
                                  <Chart
                                            width={'420px'}
                                            height={'280px'}
                                            chartType="PieChart"
                                            loader={<div>Loading Chart</div>}
                                            data={this.state.exportadorChart}
                                            options={{
                                                title: 'Paises Miembros Exportadores',
                                                legend: {position: 'bottom', textStyle: {fontSize: 11},maxLines:3},
                                                pieSliceText: 'percentage',
                                            
                                                pieStartAngle: 100,
                                            }}
                                            rootProps={{ 'data-testid': '3' }}
                                            /> 
                            </div> */}
                  {/* <div className="field-body">
                                 <Chart
                                            width={'420px'}
                                            height={'280px'}
                                            chartType="PieChart"
                                            loader={<div>Loading Chart</div>}
                                            data={this.state.importadorChart}
                                            options={{
                                                title: 'Paises Miembros Importadores',
                                                legend: {position: 'bottom', textStyle: {fontSize: 11},maxLines:3},
                                                pieSliceText: 'percentage',
                                            
                                                pieStartAngle: 100,
                                            }}
                                            rootProps={{ 'data-testid': '2' }}
                                            /> 
                            </div> */}
                </div>
              </div>
            </div>
            <div className="card has-table">
              <div className="notification is-card-toolbar">
                <div className="level">
                  <div className="level-left">
                    <div className="level-item">
                    <strong>{this.props.language('deco_listresultados')}</strong> 
                    </div>
                  </div>
                  <div className="level-right">
                            <div className="level-item">
                    {this.props.language("encontrar", "Se encontraron")}{" "}
                    <strong className="mx-1">{this.state.total}</strong>
                    {this.props.language("registros", "registros")}
                    </div>
                            </div>
                </div>
              </div>
              <div className="card-content">
              <div className="column">
                <div className="control"><div className="buttons is-justify-content-right"><button onClick={ this.onClick_descargar } id="btnGenerar" className="button is-primary"><i className="fas fa-download"></i>&nbsp;{ this.props.language('descargar', 'Descargar') }</button></div></div>
                </div>
                <div align="right"></div>
                <div className="b-table has-pagination">
                  <div className="table-wrapper has-mobile-cards">
                    <table
                      id="tblPermiso"
                      className="table is-fullwidth is-striped is-hoverable is-fullwidth"
                    >
                      <thead>
                        <tr>
                          <th> # </th>
                          <th>{this.props.language("year", "Año")}</th>
                          <th>{this.props.language("rep_perm_nombrecientifo", "Nombre Científico")}</th>
                          <th>{this.props.language("cantidad", "Cantidad")}</th>
                          <th>{this.props.language("rep_perm_unidad", "Unidad")}</th>
                          <th>{this.props.language("rep_perm_paisexport", "Exportador")}</th>
                          <th>{this.props.language("rep_perm_paisimport", "Importador")}</th>
                          <th>{this.props.language("rep_perm_fecha", "Fecha")}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                  {/* <div className="notification">
                                    <div className="level">
                                    <div className="level-left">
                                        <div className="level-item">
                                        <div className="buttons has-addons">
                                            <button type="button" className="button is-active">1</button>
                                            <button type="button" className="button">2</button>
                                            <button type="button" className="button">3</button>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="level-right">
                                        <div className="level-item">
                                        <small>Page 1 of 3</small>
                                        </div>
                                    </div>
                                    </div>
                                </div>  */}
                </div>
              </div>
            </div>
          </section>
        </div>
      </Templates.Default.BasePageRoute2>
    ) : (
      <div className="columns is-justify-content-center mb-6">
        <div className="column is-12">
          <div className="field is-horizontal">
            <div className="field-body">
              <div className="field pt-2">
                <div
                  ref={this.spinnerLoad}
                  className="ld ld-spinner  ld-spin"
                ></div>
              </div>
              <div className="field">
                <h2 className="tamano is-2"> Cargando... </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// export default connect(null, {set_datapage})(PermisoCites)
export default connect(getMapStateDefault(), {
  set_datapage,
  seDatatDocumentos,
  // setEstandarData,
  // checkEstandarData,
  checkDataDirectorio,
})(PermisoCites);
